/**
 * PillarIcons.jsx
 * Official uploaded brand icons for the four TCL pillars.
 * Used by FourPillarsGrid, Pillars page, CFQResultsPanel, and modules.
 *
 * DO NOT substitute, recreate, or restyle these images.
 */

const BASE = 'https://customer-assets-jai6qajn.emergentagent.net/job_cd729cf5-4469-4028-b6ba-a9c891131dbe/artifacts/';

/** Canonical URL map — import this for non-component usage (e.g. PDF, emails). */
export const PILLAR_ICON_URLS = {
  selfAnchoring:         BASE + 'w2yayl1v_01_self_anchoring.png',
  perspectiveShifting:   BASE + 'bepwnrlv_02_perspective_shifting.png',
  adaptiveCommunication: BASE + 'hu0i44tv_03_adaptive_communication.png',
  relationalIntegration: BASE + 'qcfrda3l_04_relational_integration.png',
};

const icon = (src, alt, size, className) => (
  <img
    src={src}
    alt={alt}
    width={size}
    height={size}
    className={className || ''}
    style={{ objectFit: 'contain', display: 'block', flexShrink: 0 }}
    draggable={false}
  />
);

// 1. Self-Anchoring — anchor symbol
export const IconSelfAnchoring = ({ size = 56, className = '' }) =>
  icon(PILLAR_ICON_URLS.selfAnchoring,
    'Self-Anchoring icon — anchor symbol representing grounded identity and internal coherence',
    size, className);

// 2. Perspective-Shifting — magnifying-glass / perspective symbol
export const IconPerspectiveShifting = ({ size = 56, className = '' }) =>
  icon(PILLAR_ICON_URLS.perspectiveShifting,
    'Perspective-Shifting icon — magnifying glass representing cultural insight and perspective-taking',
    size, className);

// 3. Adaptive Communication — dialogue / communication symbol
export const IconAdaptiveComm = ({ size = 56, className = '' }) =>
  icon(PILLAR_ICON_URLS.adaptiveCommunication,
    'Adaptive Communication icon — dialogue symbol representing communication across difference',
    size, className);

// 4. Relational Integration — interlocking puzzle symbol
export const IconRelationalInt = ({ size = 56, className = '' }) =>
  icon(PILLAR_ICON_URLS.relationalIntegration,
    'Relational Integration icon — interlocking puzzle symbol representing shared space and connection',
    size, className);
